export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensores",
                        observations: "Observaciones",
                        modelling: "Modelado",
                        mapFeatures: "Características del mapa",
                        output: "Exportar & Informar",
                        setUp: "Configuración",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'milisegundo', plural: 'milisegundos' }, short: { singular: 'ms', plural: 'ms' } },
        seconds: { long: { singular: 'segundo', plural: 'segundos' }, short: { singular: 'seg.', plural: 'seg.' } },
        minutes: { long: { singular: 'minuto', plural: 'minutos' }, short: { singular: 'min.', plural: 'min.' } },
        hours: { long: { singular: 'hora', plural: 'horas' }, short: { singular: 'hr.', plural: 'hrs.' } },
        days: { long: { singular: 'día', plural: 'días' }, short: { singular: 'día', plural: 'días' } },
        weeks: { long: { singular: 'semana', plural: 'semanas' }, short: { singular: 'sem.', plural: 'sems.' } },
        months: { long: { singular: 'mes', plural: 'meses' }, short: { singular: 'mes', plural: 'meses' } },
        quarters: { long: { singular: 'trimestre', plural: 'trimestres' }, short: { singular: 'tri.', plural: 'tris.' } },
        years: { long: { singular: 'año', plural: 'años' }, short: { singular: 'año', plural: 'años' } },
    },
    timezone: "Zona horaria",
    custom: 'enmendado',
    period: 'período',
};
